import React from 'react';
import { ToastContext, Dropdown, Modal, Button } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../context/useAppContext';
import PropTypes from 'prop-types';
import SessionModel from '../../../models/sessionModel';
import i18n from 'i18next';
import { DateTimeInput } from '../../../components/date-time-input/dateTimeInput';

export function DateModal({ item = null, onSubmit = () => {}, onClose = () => {}, loading = false, timezone }) {
    const { t } = useTranslation();
    const locale = i18n.language;

    const [date, setDate] = React.useState(item ? item.start_date : null);
    const currentYear = new Date().getFullYear();

    // React.useEffect(() => {
    //     setDate(item ? item.start_date : null);
    // }, [item]);

    const _onSubmit = React.useCallback(() => {
        onSubmit({ date, item });
    }, [date, item]);

    if (!item) {
        return null;
    }

    return (
        <Modal
            open={Boolean(item)}
            onClose={onClose}
            title={t('ticket.sessions.actions.date.modalTitle')}
            submitButton={<Button primary disabled={loading || !date} isLoading={loading} onClick={_onSubmit} label={t('ticket.common.action.save')} />}
            cancelButton={<Button disabled={loading} onClick={onClose} label={t('ticket.common.action.cancel')} />}
        >
            <DateTimeInput
                timeLabel={t('ticket.event.start_hour')}
                dateLabel={t('ticket.event.start_date')}
                onChange={(date, dateObject) => {
                    setDate(date);
                }}
                value={date}
                dateProps={{ minYear: currentYear, maxYear: currentYear + 15 }}
                locale={locale}
                timezone={timezone}
                // error={t(dateErrors['start_date'])}
            />
        </Modal>
    );
}

DateModal.propTypes = {
    item: PropTypes.object,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    loading: PropTypes.bool,
    timezone: PropTypes.string
};

export function DateAction({ objects: selectedSessions, timezone = 'Europe/Paris', onSave = () => {} }) {
    const [itemToAction, setItemToAction] = React.useState(null);
    const toast = React.useContext(ToastContext);
    const { t } = useTranslation();
    const [{ event, organization }] = useAppContext();

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const itemsFiltered = React.useMemo(() => {
        if (!selectedSessions) {
            return [];
        }
        return selectedSessions;
    }, [selectedSessions]);

    const handleSubmit = React.useCallback(
        ({ date, item }) => {
            if (!item) {
                return;
            }

            setIsSubmitting(true);
            let session = new SessionModel(item);
            session.start_date = date;

            session
                .save({ organizationId: organization.id, eventId: event.id })
                .then(() => {
                    toast.success(t(`ticket.sessions.actions.date.success`));
                    setItemToAction(null);
                    onSave();
                })
                .catch(e => {
                    console.error(e);
                    toast.error(t(`ticket.sessions.actions.date.error`));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        },
        [event, organization, SessionModel, toast, itemToAction, onSave]
    );

    return (
        <>
            {itemToAction && (
                <DateModal
                    item={itemToAction}
                    onClose={() => setItemToAction(null)}
                    onSubmit={(date, session) => handleSubmit(date, session)}
                    loading={isSubmitting}
                    timezone={timezone}
                />
            )}
            <Dropdown.Item disabled={!(itemsFiltered.length === 1)} onClick={() => setItemToAction(itemsFiltered[0])}>
                {t('ticket.sessions.actions.date.label')}
            </Dropdown.Item>
        </>
    );
}

DateAction.propTypes = {
    objects: PropTypes.array, //required
    timezone: PropTypes.string,
    onSave: PropTypes.func
};
